import { createAction } from '@reduxjs/toolkit';
import { IUser } from '../types';

export const GET_PERFEED_FEEDBACKS = 'GET_PERFEED_FEEDBACKS';
export const GET_PERFEED_FEEDBACKS_SUCCESS = 'GET_PERFEED_FEEDBACKS_SUCCESS';
export const GET_PERFEED_FEEDBACKS_FAIL = 'GET_PERFEED_FEEDBACKS_FAIL';

export const PERFEED_FEEDBACKS_CHANGE_PAGE = 'PERFEED_FEEDBACKS_CHANGE_PAGE';

export const GET_PERFEED_REQUESTS = 'GET_PERFEED_REQUESTS';
export const GET_PERFEED_REQUESTS_SUCCESS = 'GET_PERFEED_REQUESTS_SUCCESS';
export const GET_PERFEED_REQUESTS_FAIL = 'GET_PERFEED_REQUESTS_FAIL';

export const PERFEED_REQUESTS_CHANGE_PAGE = 'PERFEED_REQUESTS_CHANGE_PAGE';

export const GET_PERFEED_REQUESTS_SETTINGS = 'GET_PERFEED_REQUESTS_SETTINGS';
export const GET_PERFEED_REQUESTS_SETTINGS_SUCCESS =
    'GET_PERFEED_REQUESTS_SETTINGS_SUCCESS';
export const GET_PERFEED_REQUESTS_SETTINGS_FAIL =
    'GET_PERFEED_REQUESTS_SETTINGS_FAIL';

export const SAVE_PERFEED_REQUESTS_SETTINGS = 'SAVE_PERFEED_REQUESTS_SETTINGS';
export const SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS =
    'SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS';
export const SAVE_PERFEED_REQUESTS_SETTINGS_FAIL =
    'SAVE_PERFEED_REQUESTS_SETTINGS_FAIL';

export const SET_PERFEED_RATING_SETTINGS = 'SET_PERFEED_RATING_SETTINGS';

export const changePageFeedbacks = createAction<number>(
    PERFEED_FEEDBACKS_CHANGE_PAGE,
);
export const changePageRequests = createAction<number>(
    PERFEED_REQUESTS_CHANGE_PAGE,
);
export const saveSettingsSuccess = createAction<{ email: number }>(
    SAVE_PERFEED_REQUESTS_SETTINGS_SUCCESS,
);
export const setRatingSettingsAction = createAction<
    | { user: IUser | null; subject: string; isAnonymous: boolean }
    | {
          link: string;
          qr: string;
          list: Array<{
              id: number;
              date: string;
              name: string;
              message?: string;
              subjects?: string[];
          }>;
      }
>(SET_PERFEED_RATING_SETTINGS);

const PerfeedActions = {
    getFeedbacks,
    changePageFeedbacks,
    getRequests,
    changePageRequests,
    getSettings,
    saveSettings,
    setRatingSettings,
};

function getFeedbacks() {
    return { type: GET_PERFEED_FEEDBACKS };
}

function getRequests() {
    return { type: GET_PERFEED_REQUESTS };
}

function getSettings() {
    return { type: GET_PERFEED_REQUESTS_SETTINGS };
}

function saveSettings(email: number) {
    return { type: SAVE_PERFEED_REQUESTS_SETTINGS, payload: { email } };
}

function setRatingSettings(user: IUser, subject: string, isAnonymous: boolean) {
    return {
        type: SET_PERFEED_RATING_SETTINGS,
        payload: { user, subject, isAnonymous },
    };
}

export default PerfeedActions;
